import script from "./CarouselTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CarouselTemplate.vue?vue&type=style&index=0&id=c867db9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c867db9e"]])

export default __exports__